import { Application, Container } from 'pixi.js';

const isTypeScript =
  typeof import.meta !== 'undefined' &&
  import.meta.env &&
  import.meta.env.MODE === 'development';

interface Flake {
  direction: number;
  turningSpeed: number;
  speed: number;
  offset: number;
  x: number;
  y: number;
  scale: any;
  anchor: any;
  rotation: number;
}

export const renderSnowflakeEffect = async (
  app: Application | null,
  width: number,
  height: number,
  effectId: string,
  effectSpriteRef: any
) => {
  const PIXI = await import('pixi.js');

  const snowflakeImagePath = isTypeScript
    ? '/src/assets/effects/snowflake.png'
    : '/assets/snowflake.png';
  const texture = await PIXI.Assets.load(snowflakeImagePath);

  // Create a container for all the maggots particles and add it to the stage
  const sprites = new PIXI.Container() as Container & {
    id?: string;
    cleanup?: () => void;
  };
  effectSpriteRef.current = sprites;
  effectSpriteRef.current.id = effectId;

  // Create an array to store all the sprites
  const flakes: Flake[] = [];
  const totalSprites = 30;

  for (let i = 0; i < totalSprites; i++) {
    // Create a new snowflake Sprite
    const flake: any = new PIXI.Sprite(texture);

    // Set anchor, scale, position, and custom properties
    flake.anchor.set(0.5);
    flake.scale.set(0.01 + Math.random() * 0.3);
    flake.x = Math.random() * width;
    flake.y = Math.random() * height;
    flake.direction = -1; // Initial direction in radians
    flake.turningSpeed = 0; // Initial turning speed
    flake.speed = 2 + Math.random() * 2; // Random movement speed
    flake.offset = Math.random() * 100; // Random offset for unique movement
    // Add the snowflake to the array and container
    flakes.push(flake);
    sprites.addChild(flake);
  }

  // Create a bounding box box for the little maggots
  const dudeBoundsPadding = 100;
  const dudeBounds = new PIXI.Rectangle(
    -dudeBoundsPadding,
    -dudeBoundsPadding,
    width + dudeBoundsPadding * 2,
    height + dudeBoundsPadding * 2
  );

  const animate = () => {
    // Iterate through the sprites and update their position
    for (let i = 0; i < flakes.length; i++) {
      const dude = flakes[i];

      dude.direction += dude.turningSpeed * 0.01;
      dude.x += Math.sin(dude.direction) * dude.speed;
      dude.y += Math.cos(dude.direction) * dude.speed;
      dude.rotation = -dude.direction - Math.PI / 2;

      // Constrain the dudes' position by testing their bounds...
      if (dude.x < dudeBounds.x) {
        dude.x += dudeBounds.width;
      } else if (dude.x > dudeBounds.x + dudeBounds.width) {
        dude.x -= dudeBounds.width;
      }

      if (dude.y < dudeBounds.y) {
        dude.y += dudeBounds.height;
      } else if (dude.y > dudeBounds.y + dudeBounds.height) {
        dude.y -= dudeBounds.height;
      }
    }
  };

  if (app) {
    app.ticker.add(animate);
    sprites.cleanup = () => {
      app.ticker.remove(animate);
    };
  }

  return sprites;
};
